import EditPencilOutlined from 'assets/svg/EditPencilOutlined';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface IDisplayNameProps {
    onEditName: () => void; // callback function to trigger on click event
    displayName: string; // initial name on load
    value?: string; // Input value
    disableEdit?: boolean; // disable edit
    showLoader?: boolean;
}

const DisplayName = (props: IDisplayNameProps) => {
    const { onEditName, displayName, value, disableEdit, showLoader } = props;

    return (
        <div className="flex items-center">
            <div className="mr-4 text-fontGray font-lg">{displayName}</div>
            {showLoader ? (
                <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
            ) : (
                !disableEdit && (
                    <span className="cursor-pointer" onClick={() => onEditName()}>
                        <EditPencilOutlined />
                    </span>
                )
            )}
        </div>
    );
};

export default DisplayName;
